export default __webpack_public_path__ + "static/media/RAFCO.7a2cb6fd.png";